// extracted by mini-css-extract-plugin
export default {"wrapper":"total-transfer_wrapper__IwI6m","buttons":"total-transfer_buttons__Ge73h","opacity-transition":"total-transfer_opacity-transition__XUQ4M"};